import { render, staticRenderFns } from "./DisputeTenderModal.vue?vue&type=template&id=05371a6b"
import script from "./DisputeTenderModal.vue?vue&type=script&lang=js"
export * from "./DisputeTenderModal.vue?vue&type=script&lang=js"
import style0 from "./DisputeTenderModal.vue?vue&type=style&index=0&id=05371a6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports